// extracted by mini-css-extract-plugin
export default {"legalContainer":"styles_legalContainer__qBT22","legalHeader":"styles_legalHeader__KKsVV","legalSubheader":"styles_legalSubheader__32oSL"};